<template>
  <div class="text-center" v-if="acceptRejectModal && acceptRejectModalData">
    <v-dialog
      v-model="acceptRejectModal"
      max-width="600"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-space-between">
              <div class="d-flex flex-row align-center">
                <p class="mb-0 font-weight-bold text-primary title">{{acceptRejectModalData.title}}</p>
              </div>
            </div>
            <v-row align="center" class="my-2">
              <v-col cols="12" v-if="acceptRejectModalData.html_content">
								<div v-html="acceptRejectModalData.content_a"></div>
							</v-col>
              <v-col cols="12" v-else>
                <p class="mb-0 text-primary font-weight-bold">{{acceptRejectModalData.content_a}}</p>
                <p class="mb-0 text-primary" v-if="acceptRejectModalData.content_b">{{acceptRejectModalData.content_b}}</p>
							</v-col>
              <v-col cols="12" v-if="withTextContent">
								<p class="mb-0 font-weight-bold">{{textInputLabel}}</p>
								<v-form ref="textForm" v-model="textFormValid">
									<v-textarea
										v-model="localTextContent"
										:rules="textRequired ? [(v) => !!(v && v.trim()) || 'Este campo es requerido'] : []"
										outlined
										dense
										clearable
										rows="3"
									></v-textarea>
								</v-form>
							</v-col>
						</v-row>
            <v-row align="center">
              <v-col cols="12">
                <div class="d-flex flex-row justify-end">
									<v-btn
										class="mx-2"
										color="white"
										depressed
										@click="startCloseModal()"
									>
										<p class="mb-0 text-primary">Cancelar</p>
									</v-btn>
									<v-btn
										depressed
										dark
										color="#959595"
										@click="confirmation"
									>
										<p class="mb-0">Aceptar</p>
									</v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'AcceptCancelModal',
	props: {
		closeModal: {
			type: Function,
		},
		acceptRejectModal: {
			type: Boolean,
			default: false
		},
		acceptRejectModalData: {
			type: Object,
			default: null
		},
		withTextContent: {
			type: Boolean,
			default: false
		},
		textRequired: {
			type: Boolean,
			default: false
		},
		textInputLabel: {
			type: String,
			default: 'Ingrese el texto'
		}
	},
  data: () => ({
		localTextContent: '',
		textFormValid: false
  }),
  mounted(){
  },
	methods: {
		startCloseModal(){
			this.localTextContent = ''
			this.closeModal()
		},
		confirmation(){
			if(this.textRequired){
				if(!this.$refs.textForm.validate()){
					const messageData = {
						message: 'Por favor completa el campo requerido.',
						title: 'Campo Requerido',
						type: 'error',
						icon: 'mdi-alert-circle',
						color: '#F4516C',
					}
					this.setMessage(messageData)
					return
				}
			}
			this.closeModal(true, this.localTextContent)
			this.localTextContent = ''
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
  .info-container{
    color: #606060;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .interaction-container.response{
    background-color: #CAE7CC;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #5E85EF;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  .icon-top{
    padding: 2px;
    margin: 0 2px;
    border-radius: 100%;
  }
  .icon-top.high{
    background-color: #F4516C;
  }
  .icon-top.medium{
    background-color: #fb8c00;
  }
  .icon-top.normal{
    background-color: #3EBFA3;
  }
  .icon-top.primary{
    background-color: #524D4D;
  }
  .icon-top.light-blue{
    background-color: #5E85EF;
  }
  .parent-subtareas{
    display: flex;
    flex-wrap: wrap;
  }
  .parent-subtareas .subtareas-checkbox{
    flex: 1 0 30%;
  }
  .notification-img{
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
  .preview-img-container{
    position: relative;
  }
  .preview-img{
    width: 50px;
    height: 50px;
    border-radius: 10px;
    object-fit: contain;
  }
  .button-preview-img{
    position: absolute;
    top: -1px;
    left: -1px;
    background-color: white;
  }
</style>